export enum ContentTypeEnum {
  excel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf = 'application/pdf',
  csv = 'text/csv',
}
